import { CnpjUtils } from '../shared/utils/cnpj.utils';
import { Component, OnInit, Inject, ViewEncapsulation, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AcordoService, DominiosService, EscritoriosService, UsuarioService } from '../shared/services/acordo-ressarcimento/api/services';
import { ConsultarPropostaService } from './consultar-proposta.service';
import { AppComponent } from '../app.component';
import { ProcedenciaAcordo, FormaPagamento, SituacaoAcordo, AcordoPaginado, Acordo, Escritorio, Paginacao } from '../shared/services/acordo-ressarcimento/api/models';
import { Observable, of } from 'rxjs';
import { LoadingService } from '../shared/services/components/loading.service';
import * as moment from 'moment';
import { ArwDoReloadService } from '../core/arw-do-reload.service';

@Component({
  selector: 'app-consultar-proposta',
  templateUrl: './consultar-proposta.component.html',
  styleUrls: ['./consultar-proposta.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class ConsultarPropostaComponent implements OnInit {
  @ViewChild('templateDetalheAcordo') private templateDetalheAcordo: TemplateRef<any>;
  public acordoPaginado: AcordoPaginado;
  public formPesquisa: FormGroup;
  public procedenciasAcordo: ProcedenciaAcordo[];
  public formasPagamento: FormaPagamento[];
  public situacoesAcordo: SituacaoAcordo[];
  public loadingLista = false;
  public listaEscritoriosFiltro: any[];
  public nomeEscritorioFiltro: any[];
  public filteredOptions: Observable<Escritorio[]>;
  public tipoPessoa = 1;
  //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
  public codigoSinistroItau = "";
  //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM
  public codigoRamo: Number;
  filteredItems: any;
  public selected = '';
  public textoJustificativaReprovacao: string;
  public page: Paginacao;
  public dadosProposta: Acordo[];
  panelOpenState = false;
  public produto = this.appComponent.codigoRamo;
  public codigoEscritorio: number;
  public nomeEscritorio: string;
  public isEscritorio: boolean;
  public escritorio: any;

  source = [];
  columnsTemplate = [];
  //@ViewChild('templateDevedor') private templateDevedor: TemplateRef<any>;
  //@ViewChild('templateStatus') private templateStatus: TemplateRef<any>;
  //@ViewChild('templateData') private templateData: TemplateRef<any>;
  //@ViewChild('templateValor') private templateValor: TemplateRef<any>;
  @ViewChild('templateAcordo') private templateAcordo: TemplateRef<any>;

  formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });

  ramoParametro: any;
  sinistroParametro: any;
  anoSinistroParametro: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    public acordoService: AcordoService,
    public dominiosService: DominiosService,
    public escritorioService: EscritoriosService,
    private route: ActivatedRoute,
    public consultarPropostaService: ConsultarPropostaService,
    public usuarioService: UsuarioService,
    private arwDoReloadService: ArwDoReloadService,
    private loading: LoadingService,
    @Inject(AppComponent) public appComponent: AppComponent) {

    console.log(acordoService);
  }

  public ngOnInit() {

    if (this.arwDoReloadService.recarregarSeOrigemArwDoSemEnvConfig(
      ['/consultar-proposta'],
      'ConsultarPropostaComponent.ngOnInit'
    )) {
      return;
    }

    if( sessionStorage.getItem('codigoEscritorio') && sessionStorage.getItem('codigoEscritorio') != "" ) {
        this.codigoEscritorio = JSON.parse(sessionStorage.getItem('codigoEscritorio'));
    }
    this.nomeEscritorio = sessionStorage.getItem('nomeEscritorio');
    this.isEscritorio = JSON.parse(sessionStorage.getItem('isEscritorio'));
    this.columnsTemplate = [
      //{ label: 'Nº Acordo', template: this.templateCodigoAcordo },
      //{ prop: 'codigoAcordoSistema', label: 'Nº Acordo'},
      { prop: 'numeroAcordoDisplay', label: 'Nº Acordo'},
      { prop: 'processoRessarcimento.codigoRamoSinistro', label: 'Ramo' },
      { prop: 'processoRessarcimento.numeroSinistro', label: 'Sinistro' },
      { prop: 'processoRessarcimento.anoSinistro', label: 'Ano' },
      { prop: 'processoRessarcimento.sequenciaItemSinistro', label: 'Item' },
      { prop: 'nomeEscritorio', label: 'Escritório' },
      { prop: 'nomeDevedorDisplay', label: 'Nome do Terceiro'},
      { prop: 'situacaoAcordo.descricao', label: 'Status'},
      //{ prop: 'dataUltimaAlteracaoDisplay', label: 'Data do acordo'},
      { prop: 'dataAcordoDisplay', label: 'Data Acordo'},
      { prop: 'valorAcordoDisplay',label: 'Valor do Acordo'},
      { label: 'Detalhes', template: this.templateAcordo }
    ];

    this.dadosProposta = undefined;
    this.criarFormPesquisa();

    this.carregarDadosPagina();

    this.carregarFormasPagamento();
    this.carregarTiposSituacoesAcordo();

  }

  carregarDadosPagina() {
    this.usuarioService.recuperarDadosUsuario().subscribe(result => {
        this.codigoRamo = result.produto;

        this.carregarProcedenciasAcordo( result.produto );

        this.formPesquisa.controls['ramoSinistro'].setValue( result.produto );

        if( result.codigoEscritorio ) {
            this.codigoEscritorio = result.codigoEscritorio;
        }

        if( result.nomeEscritorio ) {
            this.nomeEscritorio = result.nomeEscritorio;
        }

        this.isEscritorio = result.flagEscritorio;
        if( this.isEscritorio ) {
            this.formPesquisa.controls['escritorio'].setValue( result.nomeEscritorio );
            this.formPesquisa.controls['codigoEscritorio'].setValue( result.codigoEscritorio );
        }

        if (this.consultarPropostaService.isRealizaPesquisa
          && this.consultarPropostaService.isRealizaPesquisa() === true
          && this.consultarPropostaService.getParametrosPesquisa) {
          this.consultarPropostaService.setRealizaPesquisa(false);
          this.formPesquisa = this.consultarPropostaService.getFormPesquisa();
          this.pesquisarAcordos(this.consultarPropostaService.getParametrosPesquisa()['page']);
        }

        this.route.queryParams.subscribe(params => {
          this.ramoParametro = params['codRamo'];
          this.sinistroParametro = params['numSinistro'];
          this.anoSinistroParametro = params['anoSinistro'];
        });

        if (this.sinistroParametro != undefined && this.ramoParametro != undefined
          && this.anoSinistroParametro != undefined) {
          this.formPesquisa.controls['ramoSinistro'].setValue(this.ramoParametro);
          this.formPesquisa.controls['sinistro'].setValue(this.sinistroParametro);
          this.formPesquisa.controls['anoSinistro'].setValue(this.anoSinistroParametro);
          this.pesquisarAcordos(this.page);
        }

    });
  }

  private criarFormPesquisa() {
    this.formPesquisa = this.formBuilder.group({
      ramoSinistro: null,
      anoSinistro: null,
      sinistro: null,
      sequenciaItemSinistro: null,
      dataDe: null,
      dataAte: null,
      statusAcordo: null,
      codigoAcordo: this.route.snapshot.params['idAcordo'] != null ? this.route.snapshot.params['idAcordo'] : null,
      sucursal: null,
      tipoPessoa: null,
      codigoSinistroItau: null, //INEX FABRICA - Base Historica ressarcimento - 2021
      cpfCnpj: null,
      escritorio: this.nomeEscritorio != null ? this.nomeEscritorio : null,
      codigoEscritorio: this.codigoEscritorio != null ? this.codigoEscritorio : null,
      codigoProcedencia: null,
      formaPagamento: null,
      valorInicio: null,
      valorFinal: null,
      codigoModalidade: null,
      perfilAlcada: null
    });
    
    // Desabilita campos readonly
    const ramoControl = this.formPesquisa.get('ramoSinistro');
    const escritorioControl = this.formPesquisa.get('escritorio');
    if (ramoControl) ramoControl.disable();
    if (this.isEscritorio && escritorioControl) escritorioControl.disable();
  }

  habilitarJustificativa(index) {
    document.getElementById('inputJustificar_' + index).style.display = 'block';
    document.getElementById('btnReprovar_' + index).style.display = 'block';
    document.getElementById('inputJustificar_' + index).focus();
  }

  recusarAcordo(index, idAcordo) {

    var valorTextoJustificativa = (<HTMLInputElement>document.getElementById('inputJustificar_' + index)).value;

    console.log(valorTextoJustificativa, idAcordo);
  }

  public visualizarDetalhesAcordo(idAcordo: number) {
    console.log("Visualizar detalhes acordo: " + idAcordo);
    this.router.navigate(['/detalhe-proposta/' + idAcordo]);
  }

  public ngOnDestroy() {
  }

  public pessoaFisicaChange(evt) {
    var target = evt.target;
    if (target.checked) {
      this.tipoPessoa = 1
    }
  }

  public pessoaJuridicaChange(evt) {
    var target = evt.target;
    if (target.checked) {
      this.tipoPessoa = 2
    }
  }

  private carregarProcedenciasAcordo(produto: number): void {
    this.dominiosService.obterProcedenciasAcordoPorRamo( produto ).subscribe(result => {
      this.procedenciasAcordo = result;
    });
  }

  private carregarFormasPagamento(): void {
    this.dominiosService.obterFormasPagamento().subscribe(result => {
      this.formasPagamento = result;
    });
  }

  private carregarTiposSituacoesAcordo(): void {
    this.dominiosService.obterTiposSituacaoAcordo().subscribe(result => {
      this.situacoesAcordo = result;
    });
  }

  public autoCompleteBuscaEscritorio() {
    return (keyword: any): Observable<any> => {
      this.nomeEscritorioFiltro = [];

      var parametros: EscritoriosService.ObterEscritoriosParams = {
        nomeEscritorio: this.formPesquisa.controls['escritorio'].value,
        codigoRamoSinistro: this.appComponent.codigoRamo
      };

      this.escritorioService.obterEscritorios(parametros).subscribe(
        data => {
          this.listaEscritoriosFiltro = data;
          for (let key in data) {
            this.nomeEscritorioFiltro.push(data[key].nomeEscritorio);
          }
        }
      );

      return of(this.nomeEscritorioFiltro);
    };
  }

  public log(event) {
    console.log(event);
  }
  public autoCompleteBuscaEscritorioSelected($event) {
    this.selected = $event;

    for (let key in this.listaEscritoriosFiltro) {
      if (this.listaEscritoriosFiltro[key].nomeEscritorio == this.selected) {
        this.formPesquisa.controls['codigoEscritorio'].setValue(this.listaEscritoriosFiltro[key].codigoEscritorio);
      }
    }
  }

  public pesquisarAcordos(page) {

    //this.loadingLista = true;
    this.loading.open();

    let cpfCnpj = (this.formPesquisa.value['cpfCnpj'] != undefined && this.formPesquisa.value['cpfCnpj'] !== null && this.formPesquisa.value['cpfCnpj'] !== '') ?
      CnpjUtils.normalizar(this.formPesquisa.value['cpfCnpj']) : undefined;

    if (this.tratarCondicao(this.escritorio) == null && this.isEscritorio === false) {
      this.formPesquisa.controls['codigoEscritorio'].setValue(null);
    }

    var parametros: AcordoService.ObterAcordosParams = {
      codigoFormaPagamento: this.formPesquisa.value['formaPagamento'] != null ? Number(this.formPesquisa.value['formaPagamento']) : undefined,
      codigoStatus: this.formPesquisa.value['statusAcordo'] != null ? Number(this.formPesquisa.value['statusAcordo']) : undefined,
      codigoTipoPessoa: this.formPesquisa.value['tipoPessoa'] != null ? this.formPesquisa.value['tipoPessoa'].toString() : undefined,
      codigoTipoProcedencia: this.formPesquisa.value['codigoProcedencia'] != null ? Number(this.formPesquisa.value['codigoProcedencia']) : undefined,
      cpfCnpj: cpfCnpj,
      codigoEscritorio: this.formPesquisa.value['codigoEscritorio'] != null ? Number(this.formPesquisa.value['codigoEscritorio']) : undefined,
      numeroAcordo: this.formPesquisa.value['codigoAcordo'] != null ? Number(this.formPesquisa.value['codigoAcordo']) : undefined,
      numeroSinistro: this.formPesquisa.value['sinistro'] != null ? Number(this.formPesquisa.value['sinistro']) : undefined,
      page: page == undefined ? 0 : Number(page), //--Ajustar depois
      perPage: 10, //-- Ajustar depois
      periodoFinal: this.formPesquisa.value['dataAte'] != null ? this.formPesquisa.value['dataAte'].toString() : null,
      periodoInicial: this.formPesquisa.value['dataDe'] != null ? this.formPesquisa.value['dataDe'].toString() : null,
      ramoSinistro: this.formPesquisa.value['ramoSinistro'] != null ? Number(this.formPesquisa.value['ramoSinistro']) : undefined,
      anoSinistro: this.formPesquisa.value['anoSinistro'] != null ? Number(this.formPesquisa.value['anoSinistro']) : undefined,
      sequenciaItemSinistro: this.formPesquisa.value['sequenciaItemSinistro'] != null ? Number(this.formPesquisa.value['sequenciaItemSinistro']) : undefined,
      sucursal: this.formPesquisa.value['sucursal'] != null && this.formPesquisa.value['sucursal'] !== '' ? Number(this.formPesquisa.value['sucursal']) : undefined,
      valorFinal: this.formPesquisa.value['valorFinal'] != null ? Number(this.formPesquisa.value['valorFinal']) : undefined,
      valorInicial: this.formPesquisa.value['valorInicio'] != null ? Number(this.formPesquisa.value['valorInicio']) : undefined,
      codigoModalidade: this.formPesquisa.value['codigoModalidade'] != null && this.formPesquisa.value['codigoModalidade'] !== '' ? Number(this.formPesquisa.value['codigoModalidade']) : undefined,
      perfilAlcada: this.formPesquisa.value['perfilAlcada'] != null && this.formPesquisa.value['perfilAlcada'] !== '' ? Number(this.formPesquisa.value['perfilAlcada']) : undefined,
      //INEX FABRICA - Base Historica ressarcimento - 2021 - INI
      codigoSinistroItau: this.formPesquisa.value['codigoSinistroItau'] != null ? this.formPesquisa.value['codigoSinistroItau'].toString() : null,
      //INEX FABRICA - Base Historica ressarcimento - 2021 - FIM
    };

    this.consultarPropostaService.addDadosPesquisa(parametros, this.formPesquisa);

    this.acordoService.obterAcordos(parametros).subscribe(response => {
      this.loading.close();
      this.acordoPaginado = response;
      this.dadosProposta = this.acordoPaginado.acordos;
      this.page = this.acordoPaginado.paginacao;
      this.loadingLista = false;
      this.source = this.acordoPaginado.acordos;
      this.prepareSource();
    }, error => {
      this.loading.close();
      const theError: string = error.error.mensagens[2].mensagem;
      this.loadingLista = false;
      this.appComponent.createAlert("Erro ao efetivar consulta!", 'error');
      console.log('Erro ao criar a proposta!' + error);
    });

  }

  public paginar(evt) {
    this.pesquisarAcordos(evt.offset);
  }

  public limparPesquisa() {
    this.ngOnInit();
  }

  prepareSource(){
    if(this.source != undefined && this.source.length > 0){

      for( let i = 0; i < this.source.length; i++) {
        this.source[i].numeroAcordoDisplay = this.source[i].codigoAcordo + " / " + this.source[i].codigoAcordoSistema;

        if(this.source[i].devedores != undefined){
          this.source[i].nomeDevedorDisplay = this.source[i].devedores[0].nome;
        } else {
          this.source[i].nomeDevedorDisplay = "Não encontrado";
        }

        this.source[i].dataUltimaAlteracaoDisplay =
          moment(this.source[i].auditoria.dataUltimaAlteracao, "YYYY-MM-DD").format("DD/MM/YYYY");

        this.source[i].valorAcordoDisplay = this.formatter.format(this.source[i].valorAcordo);

        this.source[i].dataAcordoDisplay = 
        moment(this.source[i].dataDivida, "YYYY-MM-DD").format("DD/MM/YYYY");

      }
    }
  }

  public tratarCondicao(valor: any) {
    if (valor !== undefined && valor !== null && valor === '') {
      return null;
    }
    return valor;
  }

}
